import { render, staticRenderFns } from "./InactiveTelephonyCard.vue?vue&type=template&id=706400c9&scoped=true"
import script from "./InactiveTelephonyCard.vue?vue&type=script&lang=js"
export * from "./InactiveTelephonyCard.vue?vue&type=script&lang=js"
import style0 from "./InactiveTelephonyCard.vue?vue&type=style&index=0&id=706400c9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706400c9",
  null
  
)

export default component.exports